import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import './assets/style/element/index.css';
import './assets/style/animate.css';
import './assets/style/theme.less';
import App from './App.vue';
import store from './store';
import Share from 'vue-social-share';
import './assets/style/client.css';
import '@babel/polyfill';
import router from './router';
import WechatSDK from '@/plugins/wxjssdk';

const { search, origin, hash, pathname } = location;
if (search) {
	//清除ticket
	location.href = origin + pathname + hash;
}

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Share);
Vue.use(WechatSDK);

// router.afterEach((to,from,next) => {
//   document.body.scrollTop = 0
// });
store.registerModule('app', {
	state: {
		isLoading: false,
		dataLoading: false,
		activityId: '',
	},
	mutations: {
		updateActivityId(state, payload) {
			state.activityId = payload;
		},
		updateLoadingStatus(state, payload) {
			state.isLoading = payload.isLoading;
		},
		updateDataLoading(state, payload) {
			state.dataLoading = payload.loading;
		},
	},
	actions: {
		updatePosition({ commit }, top) {
			commit({ type: 'updatePosition', top });
		},
	},
});

// router.beforeEach((to, from, next) => {
// 	console.log(store);
// store.commit('updateLoadingStatus', { isLoading: true });
// let user = JSON.parse(sessionStorage.getItem('user'));
// const env = process.env.NODE_ENV;
// if (user===null && to.path !== '/login'){
//   // if(env=='ajk'){
//   //   next({ path: '/admin/#/login'});
//   // }else{
//    if(to.path === '/resetPassword'){
//     next();
//    }else if(to.path === '/register'){
//     next();
//    }else{
//     next({ path: '/login' });
//    }
// }else if(user && to.path === '/login'){
//   ;
//   if(env=='ajk'){
//     next({ path: '/live'});
//   }else{
//     next({ path: '/package'});
//   }
// }else{
// next();
// }
// });
// router.afterEach(() => {
//   // store.commit('updateLoadingStatus', { isLoading: false });
// });

new Vue({
	store,
	router,
	render: (h) => h(App),
}).$mount('#app');
